import styled from '@emotion/styled'
import { ReactNode } from 'react'

type SectionPropsType = {
	title: string | ReactNode
	children: ReactNode
}

const SectionWrapper = ({ title, children }: SectionPropsType) => {
	return (
		<Section>
			<SectionHeader>
				{typeof title === 'string' ? <HeaderTitle>{title}</HeaderTitle> : title}
			</SectionHeader>
			{children}
		</Section>
	)
}

const Section = styled.section`
	display: flex;
	flex-direction: column;
	padding-right: 2.7rem;
	padding-left: 2.7rem;
	padding-top: 2.5rem;
	padding-bottom: 3.6rem;
	border-radius: 2rem;
	width: 100%;

	background-color: #f8f9fc;
	& + & {
		margin-top: 3rem;
	}
`

const SectionHeader = styled.div`
	border-bottom: 1px solid #efefef;
	width: 100%;
	padding-bottom: 2rem;
	margin-bottom: 3.6rem;
`

const HeaderTitle = styled.h3`
	color: #000;
	font-family: Pretendard;
	font-size: 20px;
	font-style: normal;
	font-weight: 700;
	line-height: normal;
	letter-spacing: 0.2px;
`

export default SectionWrapper
